// extracted by mini-css-extract-plugin
export default {"li":"styles_li__k8v4g","active":"styles_active__iUbrK"};